// extracted by mini-css-extract-plugin
export default {"container":"Teammate_container__TT6c0","name":"Teammate_name__Q917j","removeButton":"Teammate_removeButton__8ypx2"};